<template>
  <div class="error-wrap">
    <img class="error-image" :src="Error" alt />
    <div class="error-text">
      <p>{{ msg }}</p>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Error from "@/assets/images/error-2.png";
export default {
    name: "error_404",
    data() {
        return {
            Error,
            msg: ''
        };
    },
    mounted() {
        this.msg = this.$route.query.msg;
    }
};
</script>

<style lang="less" scoped>
.error {
    &-wrap {
        position: absolute;
        width: 100%;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
        text-align: center;
    }
    &-image {
        width: 300px;
        margin-left: 40px;
    }
    &-text {
        p {
            max-width: 400px;
            margin: 0 auto;
            padding-top: 40px;
            font-size: 20px;
            color: #fff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// 404.vue?31d3c6b8